import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';

//constants

//entities
import { EmployeeActivationRequest } from '../../entities/EmployeeActivationRequest';

//filters

//providers
import { EmployeeService }         from '../../services/Employee.service';

//util

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';

@Component({
  selector: 'my-employeeactivationrequests-grid',
  templateUrl: './EmployeeActivationRequestsGrid.component.html'
})
export class EmployeeActivationRequestsGridComponent implements OnInit {

    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;

    employeeActivationRequests: EmployeeActivationRequest[];
    cols: any[];

    constructor(private employeeService: EmployeeService) 
    {

    }

    ngOnInit(): void {
        
       this.load();
       this.loadColumns();
    }

    onSearchClick(event: any){
        this.load();
    }

    loadColumns(){
        //Note: this is only needed for the p-table exportCSV function to work. Without loading the columns, that will throw an error.
        this.cols = [
            { field: 'ID', header: 'ID' },
            { field: 'Username', header: 'Username' },
            { field: 'Location', header: 'Location' },
            { field: 'EmployeeActivationRequestStatus.Name', header: 'Status' },
            { field: 'CreatedDate', header: 'Created Date' },
        ];
    }

    load(){
        this.employeeService.getEmployeeActivationRequests().subscribe(x=>
            {
                this.employeeActivationRequests = x;
            })
    }
}